import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress, Container, Stack, Avatar, Skeleton, Radio, RadioGroup } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { AmyPorterfield, clientPointWhite, dolbyWhite, ewLogo, fb, foundrWhite, keapWhite, linkdin, Logo, LogoDarkMode, mail, microsoft, dayTrialCloud, susieMoore, teachableWhite, } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon, MicrosoftIcon, RightArrow, TickSymbolThin } from '../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import umbrellaSignBg from "../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AccountVerification from '../modals/AccountVerification'
import moment from 'moment-timezone';
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { Applications } from '../types/enums'
import { toast } from 'react-toastify'
import { SocialProvider } from '../types/auth'
import { config } from '../config'
import theme from '../theme'
import { LIVE_PRICES, AUTOMATED_PRICES, LIVE_AUTO_PRICES, PricingTier } from '../components/subscription/pricing/pricingData';
import { formatPlanName, validateEmail, generateSecurePassword } from '../utils/common.util'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'
import { PLAN_NAMES } from '../constants/planNames'
import { ArrowForward } from '@mui/icons-material'
import EventsLoggerService from '../services/events-logger.service'
import { 
    SIGNUP_FLOWS,
    logEvent,
    EVENT_TYPES,
    SIGNUP_STEPS
} from '../utils/events.util'
import PasswordStrengthIndicator from '../components/common/PasswordStrengthIndicator'

// Add CheckCircleIcon component
const CheckCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
        <path d="M24.5459 11.6742C24.1194 11.2291 23.6786 10.7697 23.5014 10.342C23.3373 9.945 23.3286 9.35766 23.3188 8.73641C23.3034 7.71047 23.2859 6.54891 22.5072 5.77016C21.7284 4.99141 20.5625 4.97391 19.5409 4.95859C18.9197 4.94875 18.3378 4.94 17.9353 4.77594C17.5077 4.59875 17.0483 4.15797 16.6031 3.73141C15.8769 3.03578 15.0544 2.24609 14 2.24609C12.9456 2.24609 12.1231 3.03578 11.3969 3.73141C10.9517 4.15797 10.4923 4.59875 10.0647 4.77594C9.66766 4.94 9.08031 4.94875 8.45906 4.95859C7.43312 4.97391 6.27156 4.99141 5.49281 5.77016C4.71406 6.54891 4.69656 7.71484 4.68125 8.73641C4.67141 9.35766 4.66266 9.93953 4.49859 10.342C4.32141 10.7697 3.88063 11.2291 3.45406 11.6742C2.75844 12.4005 1.96875 13.223 1.96875 14.2773C1.96875 15.3317 2.75844 16.1542 3.45406 16.8805C3.88063 17.3256 4.32141 17.785 4.49859 18.2127C4.66266 18.6097 4.67141 19.197 4.68125 19.8183C4.69656 20.8442 4.71406 22.0058 5.49281 22.7845C6.27156 23.5633 7.4375 23.5808 8.45906 23.5961C9.08031 23.6059 9.66219 23.6147 10.0647 23.7787C10.4923 23.9559 10.9517 24.3967 11.3969 24.8233C12.1231 25.5189 12.9456 26.3086 14 26.3086C15.0544 26.3086 15.8769 25.5189 16.6031 24.8233C17.0483 24.3967 17.5077 23.9559 17.9353 23.7787C18.3323 23.6147 18.9197 23.6059 19.5409 23.5961C20.5669 23.5808 21.7284 23.5633 22.5072 22.7845C23.2859 22.0058 23.3034 20.8442 23.3188 19.8183C23.3286 19.197 23.3373 18.6152 23.5014 18.2127C23.6786 17.785 24.1194 17.3256 24.5459 16.8805C25.2416 16.1542 26.0312 15.3317 26.0312 14.2773C26.0312 13.223 25.2416 12.4005 24.5459 11.6742ZM23.5987 15.9727C23.088 16.5042 22.5597 17.0555 22.2862 17.7117C22.0259 18.3395 22.015 19.0811 22.0041 19.7986C21.992 20.6123 21.9789 21.4545 21.5775 21.857C21.1761 22.2595 20.3328 22.2716 19.5191 22.2836C18.8016 22.2945 18.06 22.3055 17.4322 22.5658C16.7759 22.837 16.2291 23.3653 15.692 23.8783C15.1178 24.4252 14.5239 24.9983 13.9978 24.9983C13.4717 24.9983 12.8778 24.4284 12.3025 23.8783C11.7709 23.3675 11.2197 22.8392 10.5634 22.5658C9.93563 22.3055 9.19406 22.2945 8.47656 22.2836C7.66281 22.2716 6.82062 22.2584 6.41813 21.857C6.01562 21.4556 6.00359 20.6123 5.99156 19.7986C5.98062 19.0811 5.96969 18.3395 5.70938 17.7117C5.43813 17.0555 4.90984 16.5086 4.39688 15.9716C3.85109 15.3973 3.28125 14.8034 3.28125 14.2773C3.28125 13.7513 3.85109 13.1573 4.40125 12.582C4.91203 12.0505 5.44031 11.4992 5.71375 10.843C5.97406 10.2152 5.985 9.47359 5.99594 8.75609C6.00797 7.94234 6.02109 7.10016 6.4225 6.69766C6.82391 6.29516 7.66719 6.28312 8.48094 6.27109C9.19844 6.26016 9.94 6.24922 10.5678 5.98891C11.2241 5.71766 11.7709 5.18938 12.308 4.67641C12.88 4.12844 13.4739 3.55859 14 3.55859C14.5261 3.55859 15.12 4.12844 15.6953 4.67859C16.2269 5.18938 16.7781 5.71766 17.4344 5.99109C18.0622 6.25141 18.8037 6.26234 19.5212 6.27328C20.335 6.28531 21.1772 6.29844 21.5797 6.69984C21.9822 7.10125 21.9942 7.94453 22.0063 8.75828C22.0172 9.47578 22.0281 10.2173 22.2884 10.8452C22.5597 11.5014 23.088 12.0483 23.6009 12.5853C24.1478 13.1595 24.7209 13.7534 24.7209 14.2795C24.7209 14.8056 24.1489 15.3973 23.5987 15.9727ZM18.8388 11.1886C18.9616 11.3116 19.0307 11.4784 19.0307 11.6523C19.0307 11.8263 18.9616 11.993 18.8388 12.1161L12.7137 18.2411C12.5907 18.364 12.4239 18.433 12.25 18.433C12.0761 18.433 11.9093 18.364 11.7863 18.2411L9.16125 15.6161C9.04533 15.4917 8.98222 15.3272 8.98522 15.1571C8.98822 14.9871 9.0571 14.8249 9.17733 14.7047C9.29757 14.5844 9.45978 14.5156 9.62979 14.5126C9.79981 14.5096 9.96435 14.5727 10.0887 14.6886L12.25 16.8487L17.9112 11.1886C18.0343 11.0657 18.2011 10.9967 18.375 10.9967C18.5489 10.9967 18.7157 11.0657 18.8388 11.1886Z" fill="black" />
    </svg>
);

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
    value,
    onChange,
    ...restProps
}) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'us',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
            disableCountryGuess: true,
            forceDialCode: true,
        });

    return (
        <TextField
            variant="outlined"
            label="Phone number"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: '3px',
                    borderColor: '#666666',
                },

                " .MuiInputLabel-root.Mui-focused": {
                    color: "inherit",
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#333333',
                    border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                    padding: '14px 16px',
                    background: '#ffffff',
                    borderRadius: '8px'
                },
                "&.MuiInputBase-input::placeholder": {
                    color: '#333333',
                    fontSize: '16px',
                    opacity: '0.8'
                },
            }}

            slotProps={{
                input: {
                    startAdornment: <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value as CountryIso2)}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                },
            }}
            {...restProps}
        />
    );
};

const WebinarconAgencyBundleSignup = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPromoField, setShowPromoField] = useState(false);
    const [value, setValue] = React.useState(0);
    const [passwordError, setPasswordError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [leadSquaredId, setLeadSquaredId] = useState<string>('');
    const [cards] = useState([
        {
            name: "Amy Porterfield",
            title: "Online Marketing Expert",
            testimonial: `"I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!"`,
            avatar: "https://www.amyporterfield.com/wp-content/uploads/2022/12/Amy-Porterfield-Headshot-Course-Creator-2-2-scaled.jpg"
        }
    ]);

    const getTimezoneString = () => {
        const timezone = moment.tz.guess() || "UTC";
        const offset = moment.tz(timezone).format("Z");
        const zoneName = moment.tz(timezone).zoneName();
        return `(GMT${offset}),${timezone},${zoneName}`;
    };

    const generateFirstName = (email: string) => {
        const emailParts = email.split("@")[0];
        const name = emailParts
            .split(/[._-]/)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(" ");
        return name;
    };

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        timezone: getTimezoneString(),
        subdomain: ''
    });

    // Auto-generate strong password on component mount
    useEffect(() => {
        const autoGeneratedPassword = generateSecurePassword();
        setFormData(prev => ({
            ...prev,
            password: autoGeneratedPassword
        }));
    }, []);
    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
        subdomain: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isAutoRegistering, setIsAutoRegistering] = useState(false);
    const [isCardReady, setIsCardReady] = useState(false);
    const [isCardValid, setIsCardValid] = useState(false);

    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });

    const [cardToken, setCardToken] = useState<string>("");
    const [cardError, setCardError] = useState<string | null>(null);
    const cardRef = useRef<any>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const [planDetails, setPlanDetails] = useState<any>(null);
    const [isLoadingPlan, setIsLoadingPlan] = useState(false);
    const [isTrial, setIsTrial] = useState(false);
    const [noTrial, setNoTrial] = useState(false);
    const [monthlyPlanDetails, setMonthlyPlanDetails] = useState<any>(null);
    const [initialPlanId, setInitialPlanId] = useState<string | null>(null);

    const [promoCode, setPromoCode] = useState('');
    const [appliedPromo, setAppliedPromo] = useState<{
        code: string;
        discount: number;
        type: string;
    } | null>(null);
    const [promoError, setPromoError] = useState('');

    const [domainSuggestions, setDomainSuggestions] = useState<string[]>([]);

    const planId = searchParams.get('planId');
    const cleanPlanId = planId ? planId.replace(/-\d+$/, '') : undefined;

    // Initialize billing period from URL
    const initializeBillingPeriodFromUrl = () => {
        if (cleanPlanId) {
            return cleanPlanId.includes("Yearly");
        }
        return true; // Default to yearly
    };

    const [isYearly, setIsYearly] = useState(initializeBillingPeriodFromUrl());

    // Update plan in URL when billing period changes
    const updatePlanInUrl = (newIsYearly: boolean) => {
        if (!planId) return;

        // Extract the attendee number from the current planId
        const attendeeMatch = planId.match(/-(\d+)$/);
        const attendeeNumber = attendeeMatch ? attendeeMatch[1] : '250'; // Default to 250 if no number found

        // Extract the base plan ID without period and attendee number
        const basePlanId = planId.replace(/(Monthly|Yearly)/g, "").replace(/-\d+$/, "");
        const period = newIsYearly ? "Yearly" : "Monthly";
        const newPlanId = `${basePlanId}${period}-${attendeeNumber}`;

        setSearchParams((prev) => {
            prev.set("planId", newPlanId);
            return prev;
        }, { replace: true });
    };

    const handleBillingPeriodChange = (newIsYearly: boolean) => {
        // If the user clicks on the already selected option, do nothing
        if (isYearly === newIsYearly) {
            return;
        }

        setIsYearly(newIsYearly);
        updatePlanInUrl(newIsYearly);

        // Swap the plan details without making API calls
        if (planDetails && monthlyPlanDetails) {
            if (newIsYearly) {
                // Switching to yearly: set planDetails to yearly, monthlyPlanDetails to monthly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains yearly data
                setMonthlyPlanDetails(planDetails); // planDetails contains monthly data
            } else {
                // Switching to monthly: set planDetails to monthly, monthlyPlanDetails to yearly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains monthly data
                setMonthlyPlanDetails(planDetails); // planDetails contains yearly data
            }
        }
    };

    // Store planId in localStorage when component mounts
    useEffect(() => {
        if (planId) {
            localStorage.setItem('planId', planId);
        }
    }, [planId]);

    useEffect(() => {
        const fetchPlanDetails = async () => {
            if (!initialPlanId) return;

            const cleanInitialPlanId = initialPlanId.replace(/-\d+$/, '');
            setIsLoadingPlan(true);
            try {
                // Fetch both monthly and yearly plan details at once using clean plan IDs without numbers
                const basePlanId = cleanInitialPlanId.replace(/(Monthly|Yearly)/g, "");
                const monthlyPlanId = `${basePlanId}Monthly`;
                const yearlyPlanId = `${basePlanId}Yearly`;

                // Fetch both plans in parallel
                const [monthlyResponse, yearlyResponse] = await Promise.all([
                    chargebeeService.getPlanById(monthlyPlanId),
                    chargebeeService.getPlanById(yearlyPlanId)
                ]);

                // Store both plan details
                setPlanDetails(isYearly ? yearlyResponse.data : monthlyResponse.data);
                setMonthlyPlanDetails(isYearly ? monthlyResponse.data : yearlyResponse.data);

            } catch (error) {
                console.error('Failed to fetch plan details:', error);
                // Fallback: try to fetch just the current plan
                try {
                    const response = await chargebeeService.getPlanById(cleanInitialPlanId);
                    setPlanDetails(response.data);
                } catch (fallbackError) {
                    console.error('Failed to fetch fallback plan details:', fallbackError);
                }
            } finally {
                setIsLoadingPlan(false);
            }
        };

        fetchPlanDetails();
    }, [initialPlanId]); // Only depend on initialPlanId, not planId

    useEffect(() => {
        // Extract plan details from planId and console log them
        if (planId) {
            // Parse the planId
            const parts = planId.split('-');
            let extractedPlanType: string;
            let currency: string;
            let duration: string;
            let extractedAttendees: number;
            let liveAttendees: number = 0;
            let automatedAttendees: number = 0;

            if (parts[0] === 'All') {
                extractedPlanType = PLAN_NAMES.ALL_IN_ONE; // "All-In-One"
                currency = parts[3]; // USD
                duration = parts[4]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[5]); // e.g., 750

                // Find the matching plan to get the label
                const selectedPlan = LIVE_AUTO_PRICES.find(plan => plan.value === extractedAttendees.toString());
                if (selectedPlan) {
                    // Parse the label to extract live and automated attendees, handling comma-separated numbers
                    const labelMatch = selectedPlan.label.match(/([\d,]+)\s+Live\s+&\s+([\d,]+)\s+Automated/);
                    if (labelMatch) {
                        // Remove commas and convert to numbers
                        liveAttendees = parseInt(labelMatch[1].replace(/,/g, ''));
                        automatedAttendees = parseInt(labelMatch[2].replace(/,/g, ''));
                    }
                }
            } else {
                extractedPlanType = parts[0] + '-' + parts[1]; // Could be LIVE_WEBINARS or AUTOMATED_GOLD
                currency = parts[2]; // USD
                duration = parts[3]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[4]); // e.g., 250
            }

            // Validate that the extracted plan type is one of the valid plan names
            const validPlanTypes = [
                PLAN_NAMES.LIVE_WEBINARS,
                PLAN_NAMES.AUTOMATED_GOLD,
                PLAN_NAMES.ALL_IN_ONE
            ];

            if (!validPlanTypes.includes(extractedPlanType)) {
                console.log('Invalid plan type:', extractedPlanType, 'redirecting to pricing page');
                window.location.href = 'https://easywebinar.com/pricing/';
                return;
            }

            // Get pricing data based on plan type
            let pricingData: PricingTier[];
            let selectedPlan: PricingTier | undefined;

            switch (extractedPlanType) {
                case PLAN_NAMES.LIVE_WEBINARS:
                    pricingData = LIVE_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                case PLAN_NAMES.AUTOMATED_GOLD:
                    pricingData = AUTOMATED_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                case PLAN_NAMES.ALL_IN_ONE:
                    pricingData = LIVE_AUTO_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                default:
                    console.log('Unknown plan type:', extractedPlanType);
                    return;
            }

            if (!selectedPlan) {
                console.log('No matching plan found for attendees:', extractedAttendees);
                return;
            }

            // Update the features object
            const features = {
                planType: extractedPlanType,
                currency,
                duration,
                attendees: extractedAttendees ?? 0,
                liveAttendees: liveAttendees,
                automatedAttendees: automatedAttendees,
                price: duration === 'Yearly' ? (selectedPlan.annual ?? 0) : (selectedPlan.monthly ?? 0),
                storage: selectedPlan.storage,
                webinars: 'Unlimited'
            };

            // Get plan-specific features based on plan type
            let planFeatures = [];
            switch (extractedPlanType) {
                case PLAN_NAMES.LIVE_WEBINARS:
                    planFeatures = [
                        `Up to ${extractedAttendees} attendees`,
                        'Unlimited live webinars',
                        'Custom landing pages + smart scheduling',
                        `Up to ${selectedPlan.storage} storage space`,
                        'Share offers, files & links',
                        'Polls, Q&A, and emoji reactions'
                    ];
                    break;
                case PLAN_NAMES.AUTOMATED_GOLD:
                    planFeatures = [
                        `Up to ${extractedAttendees} attendees`,
                        'Unlimited automated events',
                        'Just-in-time scheduling',
                        'Preloaded + live chats & real-time replays',
                        'Automated, segmented email campaigns',
                        'Data export & analytics'
                    ];
                    break;
                case PLAN_NAMES.ALL_IN_ONE:
                    planFeatures = [
                        `Up to ${extractedAttendees} total attendees`,
                        'Unlimited live & automated webinars',
                        'Turn replays into automated webinars',
                        'Auto-played polls, CTAs, and chat prompts',
                        'Priority support & success onboarding',
                        'CRM Tool Integrations'
                    ];
                    break;
            }

            // Update all state variables at once to prevent multiple re-renders
            setPlanFeatures(features);
            setPlanType(extractedPlanType);
            setLeads(extractedAttendees);
            setLiveAttendees(liveAttendees);
            setAutomatedAttendees(automatedAttendees);
            setPlanPrice(duration === 'Yearly' ? (selectedPlan.annual ?? 0) : (selectedPlan.monthly ?? 0));
            setPlanWebinars('Unlimited');
            setPlanStorage(selectedPlan.storage);
        }
    }, [planId]);

    const calculateDynamicPricing = () => {
        if (isLoadingPlan || !planDetails) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        const quantity = planId ? parseInt(planId.match(/-(\d+)$/)?.[1] || '0') : 0;

        if (planId === PLAN_NAMES.FREE_TRIAL) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        // Find the current plan tier
        const currentTier = planDetails?.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return quantity >= tier.starting_unit;
            }
            return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
        });

        if (!currentTier) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        // Get current plan price
        const currentPrice = currentTier.price / 100; // Convert cents to dollars
        let discountedCurrentPrice = currentPrice;

        // Apply discount if promo code is applied
        if (appliedPromo) {
            if (appliedPromo.type === 'percentage') {
                discountedCurrentPrice = currentPrice * (1 - appliedPromo.discount / 100);
            } else if (appliedPromo.type === 'fixed_amount') {
                discountedCurrentPrice = Math.max(0, currentPrice - (appliedPromo.discount / 100));
            }
        }

        // Calculate alternative pricing
        let alternativePrice = 0;
        let alternativeTier = null;

        if (isYearly) {
            // If yearly is selected, calculate monthly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate monthly price as 1/12 of yearly price
                    alternativePrice = currentPrice;
                }
            } else {
                // Fallback: estimate monthly price as 1/12 of yearly price
                alternativePrice = currentPrice;
            }
        } else {
            // If monthly is selected, calculate yearly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    alternativePrice = currentPrice * 12;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                alternativePrice = currentPrice * 12;
            }
        }

        // Calculate static monthly and yearly prices
        let monthlyPrice = 0;
        let yearlyPrice = 0;

        // Calculate monthly price
        if (isYearly) {
            // If yearly is selected, use the monthly plan details
            if (monthlyPlanDetails) {
                const monthlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        } else {
            // If monthly is selected, use the current plan details
            if (planDetails && planDetails.periodUnit === 'month') {
                const monthlyTier = planDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        }

        // Calculate yearly price (monthly equivalent)
        if (isYearly) {
            // If yearly is selected, use the current yearly price
            yearlyPrice = discountedCurrentPrice / 12;
        } else {
            // If monthly is selected, use the actual yearly price from alternative plan details
            if (monthlyPlanDetails && monthlyPlanDetails.periodUnit === 'year') {
                // Use the fetched yearly plan details
                const yearlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (yearlyTier) {
                    let yearlyPriceValue = yearlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            yearlyPriceValue = yearlyPriceValue * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            yearlyPriceValue = Math.max(0, yearlyPriceValue - (appliedPromo.discount / 100));
                        }
                    }
                    yearlyPrice = yearlyPriceValue / 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    yearlyPrice = discountedCurrentPrice;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                yearlyPrice = discountedCurrentPrice;
            }
        }

        // Calculate savings
        let savings = 0;
        let savingsPercentage = 0;

        if (isYearly) {
            // If yearly is selected, savings = monthly equivalent - yearly price
            // Use original prices for savings calculation
            const originalAlternativePrice = alternativePrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const originalCurrentPrice = currentPrice;
            savings = Math.abs(originalAlternativePrice - originalCurrentPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === 'percentage') {
                    savings += (originalCurrentPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === 'fixed_amount') {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage = originalAlternativePrice > 0 ? Math.round((savings / originalAlternativePrice) * 100) : 0;
        } else {
            // If monthly is selected, savings = (monthly price × 12) - actual yearly price
            // Use original prices for savings calculation
            const originalMonthlyPrice = monthlyPrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const yearlyEquivalent = originalMonthlyPrice * 12;
            const actualYearlyPrice = monthlyPlanDetails ?
                (monthlyPlanDetails.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                })?.price || 0) / 100 : 0;

            savings = Math.abs(yearlyEquivalent - actualYearlyPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === 'percentage') {
                    savings += (actualYearlyPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === 'fixed_amount') {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage = actualYearlyPrice > 0 ? Math.round((savings / actualYearlyPrice) * 100) : 0;
        }

        return {
            currentPrice: `$${Math.round(discountedCurrentPrice)}`,
            originalPrice: `$${Math.round(currentPrice)}`,
            alternativePrice: `$${Math.round(alternativePrice)}`,
            savings: `$${Math.round(savings)}`,
            savingsPercentage,
            isYearlySelected: isYearly,
            currentPeriod: isYearly ? 'year' : 'month',
            alternativePeriod: isYearly ? 'month' : 'year',
            currentPriceValue: discountedCurrentPrice || 0,
            originalPriceValue: currentPrice || 0,
            alternativePriceValue: alternativePrice || 0,
            monthlyPrice: `$${Math.round(monthlyPrice)}`,
            yearlyPrice: `$${Math.round(yearlyPrice)}`
        };
    };

    const validatePassword = (password: string) => {
        const minLength = 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);

        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasNumber) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        if (!hasUppercase) {
            return 'Password must contain at least one uppercase letter';
        }
        if (!hasLowercase) {
            return 'Password must contain at least one lowercase letter';
        }
        return '';
    };



    const validateForm = () => {
        const errors = {
            email: '',
            password: '',
            subdomain: ''
        };
        let isValid = true;

        // Check required fields
        const emailValidation = validateEmail(formData.email);
        if (!emailValidation.isValid) {
            errors.email = emailValidation.error || "Please enter a valid email";
            isValid = false;
        }

        // Password validation
        if (!formData.password.trim()) {
            errors.password = 'Password is required';
            setPasswordError('Password is required');
            isValid = false;
        } else {
            const passwordValidationError = validatePassword(formData.password);
            if (passwordValidationError) {
                errors.password = passwordValidationError;
                setPasswordError(passwordValidationError);
                isValid = false;
            } else {
                setPasswordError('');
            }
        }

        setFormErrors(errors);
        return isValid;
    };


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For subdomain field, convert to lowercase
        const processedValue = name === 'subdomain' ? value.toLowerCase() : value;

        // Update the form data with the raw input value
        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));

        // Clear error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));

        if (name === 'password') {
            if (!value.trim()) {
                setPasswordError('Password is required');
            } else {
                setPasswordError(validatePassword(value));
            }
        }
    };



    const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAcceptedTerms(event.target.checked);
        if (event.target.checked) {
            setTermsError('');
        }
    };

    const [verificationDialogOpen, setVerificationDialogOpen] = React.useState(false);

    const handleVerificationDialogOpen = () => {
        setVerificationDialogOpen(true);
    };

    const handleVerificationDialogClose = async () => {
        setVerificationDialogOpen(false);
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name", "Value": 'Agency Bundle' },
                { "Attribute": "mx_Status", "Value": "Pending Verification" }
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        navigate('/login');
    };

    // Helper function to clear UTM params from localStorage
    const clearUtmParamsFromStorage = () => {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_medium');
        localStorage.removeItem('utm_campaign');
        localStorage.removeItem('utm_content');
        localStorage.removeItem('utm_term');
    };

    const handleVerificationDialogProceed = async () => {
        // handleVerificationDialogClose();
        setVerificationDialogOpen(false);
        try {
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Email Verified" });
            const leadData = {
                "leadId": leadSquaredId,
                "fields": [
                    { "Attribute": "mx_Plan_Name", "Value": 'Agency Bundle' },
                    { "Attribute": "mx_Status", "Value": "Active" }
                ]
            }
            await LeadsquaredService.updateLsField(leadData);
        } catch (error) {
            console.error('Error updating lead data:', error);
        }

        // Clear UTM parameters from localStorage after successful signup
        clearUtmParamsFromStorage();
  
        // Pass plan data through URL parameters
        const planData = {
            price: 5500,
            currency: 'USD',
            coupon: appliedPromo?.code || '',
            plan_name: 'Agency Bundle',
            customer_type: "with_cc",
            flow: 'agency-bundle'
        };

        // Encode plan data as URL parameters
        const planDataParams = new URLSearchParams({
            ...planData,
            price: planData.price.toString()
        }).toString();

        window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=Agency-Bundle-USD-Yearly&${planDataParams}`;
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 24,
        height: 24,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#178EFC',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // Only allow changing to the second tab (newValue = 1) if it's done programmatically
        // Users can always go back to the first tab (newValue = 0)
        if (newValue === 0) {
            setValue(newValue);
        }
        // The second tab (newValue = 1) can only be reached through handleNext function
        // which validates the form fields first
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSocialSignIn = (provider: SocialProvider) => {
        try {
            const authUrl = config.sso_auth_url;
            const planIdParam = searchParams.get('planId');

            const utmParams = {
                utm_source: localStorage.getItem('utm_source'),
                utm_medium: localStorage.getItem('utm_medium'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_content: localStorage.getItem('utm_content'),
                utm_term: localStorage.getItem('utm_term')
            }

            // Filter out null/undefined/empty values from UTM params
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined && value.trim() !== '')
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value?.trim() }), {});

            // Create state parameter with additional metadata
            const stateData = {
                isRegistration: true,
                timestamp: Date.now(),
                flow: 'first-flow',
                ...(planIdParam && { planId: planIdParam }), // Only include planId if it exists
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams }) // Only include UTM params if they exist
            };

            const baseParams = {
                client_id: config.sso_client_id,
                response_type: 'code',
                scope: 'email openid profile phone',
                redirect_uri: `${window.location.origin}/auth/sso/callback`,
                state: JSON.stringify(stateData),
                prompt: 'select_account'
            };

            const params = new URLSearchParams({
                ...baseParams,
                identity_provider: provider,
            });

            window.location.href = `${authUrl}?${params.toString()}`;
        } catch (error) {
            console.error('Google Sign In Error:', error);
            toast.error('Failed to initialize Google Sign In');
        }
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');

    const handleNext = async () => {
        try {
            setIsLoading(true);

            // Validation and display errors
            const isValid = validateForm();
            if (!isValid) {
                return;
            }

            // Check if email exists
            const emailCheckResponse = await AuthService.checkEmailExists(formData.email);
            if (emailCheckResponse.data?.exists) {
                toast.error("An account with this email already exists. Please use a different email or try logging in.");
                setIsLoading(false);
                return;
            }

            // Auto-generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            // Generate subdomain from first name
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain for use in step 2
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // Log signup event before moving to next step
            try {
                const planId = searchParams.get('planId');
                const eventData = {
                    step: SIGNUP_STEPS.FORM,
                    password: formData.password,
                    planId: cleanPlanId || "",
                    planUnits: planId ? planId.match(/-(\d+)$/)?.[1] || 10 : 10,
                    signupFlow: SIGNUP_FLOWS.PRICING_PAGE
                }
                
                await logEvent(formData.email, EVENT_TYPES.SIGNUP, eventData);
            } catch (error: any) {
                console.error('Error logging signup event:', error);
                // Don't block the flow if event logging fails
            }

            // If validation and subdomain generation passes, move to second step
            setValue(1);
            try {
                let utm_Data = {
                    utm_source: localStorage.getItem('utm_source'),
                    utm_medium: localStorage.getItem('utm_medium'),
                    utm_campaign: localStorage.getItem('utm_campaign'),
                    utm_content: localStorage.getItem('utm_content'),
                    utm_term: localStorage.getItem('utm_term')
                }

                // Create form data with generated firstName and lastName
                const formDataWithDetails = {
                    firstName,
                    lastName,
                    email: formData.email,
                    password: formData.password,
                    timezone: getTimezoneString(),
                    subdomain: subdomainResponse.subdomain,
                };

                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Signup Attempt - pricing" });
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
            }
        } catch (error: any) {
            console.error('Error generating subdomain:', error);
            toast.error('Failed to generate subdomain. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetStarted = async () => {
        // Add domain validation here
        if (!formData.subdomain.trim()) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain is required'
            }));
            setDomainSuggestions([]);
            return;
        } else if (!/^[a-zA-Z0-9-]+$/.test(formData.subdomain)) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain can only contain letters, numbers, and hyphens'
            }));
            setDomainSuggestions([]);
            return;
        }

        try {
            setIsLoading(true);

            // Check domain availability first
            const domainResponse = await AuthService.checkSubDomainAvailability(
                formData.subdomain,
                Applications.EASYWEBINAR
            );

            if (!domainResponse.available) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'This domain is already taken. Please try another one.'
                }));
                // Set domain suggestions if they exist
                if (domainResponse.suggestions && domainResponse.suggestions.length > 0) {
                    setDomainSuggestions(domainResponse.suggestions);
                } else {
                    setDomainSuggestions([]);
                }
                setIsLoading(false);
                return;
            }

            // Clear suggestions if domain is available
            setDomainSuggestions([]);

            let cardTokenResult = null;
            const planId = 'Agency-Bundle-USD-Yearly';

            // Only process card if there's a plan and it's not a free trial
            if (planId && !isTrial) {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }
            }

            // Get UTM parameters directly from URL
            const urlParams = new URLSearchParams(window.location.search);

            const utmParams = {
                utm_source: urlParams.get('utm_source'),
                utm_medium: urlParams.get('utm_medium'),
                utm_campaign: urlParams.get('utm_campaign'),
                utm_content: urlParams.get('utm_content'),
                utm_term: urlParams.get('utm_term')
            };

            // Remove null/undefined values from the UTM params object
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

            // Check if buyNow parameter is present and true
            const buyNow = urlParams.get('BuyNow') == 'true';


            // Generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            const signupData = {
                ...formData,
                firstName,
                lastName,
                phoneNumber: "",
                timezone: getTimezoneString(),
                planId: 'Agency-Bundle-USD-Yearly',
                planUnits: 1,
                cardToken: cardTokenResult,
                // Include UTM parameters if they exist
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams })
            };

            const response = await AuthService.signup(signupData);
            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();
            // Clear UTM params on successful signup
            clearUtmParamsFromStorage();
            toast.success('Signup successful! Please verify your account.');
            try {
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
                if(planDetails?.id === "free-trial-plan"){
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Free Plan" });
                }else{
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Agency Bundle" });
                }
            } catch (error: any) {
                console.error('Error joining activities:', error);
            }
        } catch (error: any) {
            console.error('Signup failed:', error);
            setDomainSuggestions([]);
            // Clear UTM params on signup failure too
            clearUtmParamsFromStorage();
            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
                toast.error('Invalid card details. Please try again.');
            } else {
                toast.error(error.message || 'An error occurred during signup. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateCoupon = async () => {
        if (!promoCode.trim()) {
            setPromoError('Please enter a promo code');
            toast.error('Please enter a promo code');
            return;
        }

        try {
            const planId = searchParams.get('planId');
            const response = await chargebeeService.validateCoupon(
                promoCode,
                planId ? planId.replace(/-\d+$/, '') : undefined
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount,
                    type: coupon.discountType
                });
                setPromoError('');
                setShowPromoField(false);
                toast.success('Promo code applied successfully!');
            } else {
                setPromoError(response.data.error || 'Invalid promo code');
                setAppliedPromo(null);
                toast.error(response.data.error || 'Invalid promo code');
            }
        } catch (error: any) {
            console.error('Error validating coupon:', error);
            setPromoError('Failed to validate promo code');
            setAppliedPromo(null);
            toast.error('Failed to validate promo code. Please try again.');
        }
    };

    // Inside the Signup component, add a state variable for planFeatures
    const [planFeatures, setPlanFeatures] = useState<{
        planType: string;
        currency: string;
        duration: string;
        attendees: number;
        liveAttendees?: number;
        automatedAttendees?: number;
        price: number | string;
        webinars: number | string;
        storage: string;
    } | null>(null);

    // Add new state variables to store the extracted values
    const [planType, setPlanType] = useState<string>('');
    const [leads, setLeads] = useState<number>(0);
    const [liveAttendees, setLiveAttendees] = useState<number | undefined>(undefined);
    const [automatedAttendees, setAutomatedAttendees] = useState<number | undefined>(undefined);
    const [planPrice, setPlanPrice] = useState<number | string>('');
    const [planWebinars, setPlanWebinars] = useState<number | string>('');
    const [planStorage, setPlanStorage] = useState<string>('');

    function captureUTMParams() {
        const urlParams = new URLSearchParams(window.location.search);

        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');
        const utmContent = urlParams.get('utm_content');
        const utmTerm = urlParams.get('utm_term');
        const email = urlParams.get('email');

        if (utmSource) localStorage.setItem('utm_source', utmSource);
        if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
        if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);
        if (utmContent) localStorage.setItem('utm_content', utmContent);
        if (utmTerm) localStorage.setItem('utm_term', utmTerm);
        
        // Set email from URL parameter if present
        if (email) {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }

    // Add useEffect for capturing UTM parameters
    useEffect(() => {
        captureUTMParams();
    }, []);

    /**
     * Auto-registration logic when profileId and email are present in URL parameters
     */
    useEffect(() => {
        const handleAutoRegistration = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const profileId = urlParams.get('profileId');
            const email = urlParams.get('email');

            if (profileId && email && !isLoadingPlan && planDetails) {
                try {
                    setIsAutoRegistering(true);
                    
                    // Get static profile ID
                    const staticProfileId = getStaticProfileId();
                    
                    // Check if the profileId matches our static ID
                    if (profileId === staticProfileId) {
                        
                        // Call getLatestSignupEvent API
                        const response = await EventsLoggerService.getLatestSignupEvent(email);
                        
                        if (response.data?.event?.event_data?.password) {
                            const password = response.data.event.event_data.password;
                            const planId = response.data.event.event_data.planId;
                            const planUnits = 10 //response.data.event.event_data.planUnits;
                
                            
                            // Auto-fill the form
                            setFormData(prev => ({
                                ...prev,
                                email: email,
                                password: password
                            }));
                            
                            // Generate firstName from email
                            const firstName = generateFirstName(email);
                            
                            // Proceed with automatic registration using parsed planId and units
                            await performAutoRegistration(email, password, firstName, planId, planUnits);
                        } else {
                            console.error('Password not found in event data');
                            toast.error('Unable to retrieve registration data');
                        }
                    } else {
                        console.log('Profile ID does not match, proceeding with normal flow');
                        console.log('Expected:', staticProfileId, 'Received:', profileId);
                    }
                } catch (error: any) {
                    console.error('Error during auto-registration:', error);
                    toast.error('Auto-registration failed. Please proceed with manual signup.');
                } finally {
                    setIsAutoRegistering(false);
                }
            }
        };

        handleAutoRegistration();
    }, [isLoadingPlan, planDetails]);
    
    
    // Function to get static profile ID
    const getStaticProfileId = () => {
        const STATIC_PROFILE_ID = '550e8400-e29b-41d4-a716-446655440000';
        return STATIC_PROFILE_ID;
    };

    // Function to perform automatic registration
    const performAutoRegistration = async (email: string, password: string, firstName: string, planId?: string, units?: number) => {
        try {
            setIsLoading(true);
            
            // Generate subdomain
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);
            
            // Create lead in LeadSquared
            const utm_Data = {
                utm_source: localStorage.getItem('utm_source'),
                utm_medium: localStorage.getItem('utm_medium'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_content: localStorage.getItem('utm_content'),
                utm_term: localStorage.getItem('utm_term')
            };

            const formDataWithDetails = {
                firstName,
                lastName: "",
                email: email,
                password: password,
                timezone: getTimezoneString(),
                subdomain: subdomainResponse.subdomain,
            };

            try {
                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Auto Signup Attempt" });
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
                return;
            }

            // Get UTM parameters from URL
            const urlParams = new URLSearchParams(window.location.search);
            const utmParams = {
                utm_source: urlParams.get('utm_source'),
                utm_medium: urlParams.get('utm_medium'),
                utm_campaign: urlParams.get('utm_campaign'),
                utm_content: urlParams.get('utm_content'),
                utm_term: urlParams.get('utm_term')
            };

            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
            
            // Prepare signup data
            const signupData = {
                ...formDataWithDetails,
                phoneNumber: "",
                planId: 'Agency-Bundle-USD-Yearly',
                planUnits: 1, 
                
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams })
            };

            // Perform signup
            const response = await AuthService.signup(signupData);
            
            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            
            // Clear UTM params on successful signup
            clearUtmParamsFromStorage();
            
            // Join activities
            try {
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
                if (planDetails?.id === "free-trial-plan") {
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Free Plan" });
                } else {
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Agency Bundle" });
                }
            } catch (error: any) {
                console.error('Error joining activities:', error);
            }

            logEvent(email, EVENT_TYPES.SIGNUP, {
                step: SIGNUP_STEPS.VERIFICATION,
                planId: planId,
                planUnits: units,
                autoRegistration: true
            });

            // Open verification dialog
            handleVerificationDialogOpen();
            toast.success('Auto-registration successful! Please verify your account.');
            
        } catch (error: any) {
            console.error('Auto-registration failed:', error);
            toast.error(error.message || 'Auto-registration failed. Please try manual signup.');
        } finally {
            setIsLoading(false);
        }
    };
    // Check for BuyNow parameter on page load
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const buyNow = urlParams.get('BuyNow') === 'true';
        setNoTrial(buyNow);
    }, []);

    return (
        <>
            {/* Auto-registration loading overlay */}
            {isAutoRegistering && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        color: 'white',
                    }}
                >
                    <CircularProgress size={60} sx={{ color: 'white', mb: 2 }} />
                    <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
                        Setting up your account...
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'white', opacity: 0.8 }}>
                        Please wait while we complete your registration
                    </Typography>
                </Box>
            )}
            
            <Box
                sx={{
                    minHeight: "100vh",
                    width: "100vw",
                    background: `
                linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
                linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
            `,
                    color: "#1f2937",
                    fontFamily: "Inter",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: { xs: "16px 24px", sm: "24px 32px" },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={LogoDarkMode}
                            alt="logo"
                            style={{ height: 24, cursor: "pointer", maxWidth: "100%" }}
                            onClick={() => window.open("https://easywebinar.com/", "_blank")}
                        />
                    </Box>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward />}
                        size="small"
                        onClick={() => navigate("/login")}
                        sx={{
                            bgcolor: "#6066E9",
                            color: "#fff",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#4B4EB5" },
                        }}
                    >
                        Login
                    </Button>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto" },
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#ffffff",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Left side - Promotional Section */}
                        <Box
                            sx={{
                                width: "50%",
                                bgcolor: "#f8fafc",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: { xs: "none", md: "flex" },
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            {value === 0 || noTrial ? (
                                <>
                                    {/* Main heading with statistics */}
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "22px" },
                                            textAlign: "center",
                                            mb: 10,
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        EasyWebinar has powered{" "}
                                        <Box component="span" sx={{ fontWeight: 700, }}>
                                            200K+
                                        </Box> <br />
                                        webinars with over{" "}
                                        <Box component="span" sx={{ fontWeight: 700, }}>
                                            69M+
                                        </Box>{" "}
                                        registrations and counting...
                                    </Typography>

                                    {/* Testimonial Block */}
                                    <Box sx={{ mb: 10 }}>
                                        <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ maxWidth: 477, margin: "auto" }}>
                                            <Box
                                                component="img"
                                                src={AmyPorterfield}
                                                alt="Amy Porterfield"
                                                sx={{
                                                    width: { xs: 100, sm: 150, md: 180 },
                                                    height: { xs: 100, sm: 150, md: 180 },
                                                    borderRadius: "8px",
                                                    objectFit: "cover",
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Box sx={{ flex: 1 }}>
                                                <Stack direction="row" spacing={0.5} mb={1}>
                                                    {[...Array(5)].map((_, i) => (
                                                        <StarRoundedIcon key={i} sx={{ color: '#FDBF2F', fontSize: "16px" }} />
                                                    ))}
                                                </Stack>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: "#374151",
                                                        fontSize: "16px",
                                                        lineHeight: 1.5,
                                                        mb: 1,
                                                    }}
                                                >
                                                    "I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!"
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: theme.palette.text.secondary,
                                                        fontWeight: 600,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    Amy Porterfield
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: theme.palette.text.tertiary,
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    Online Marketing Expert
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </Box>

                                    {/* Shield Badges */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2,
                                            mb: 4,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {/* G3 Icons Group Image */}
                                        <Box
                                            component="img"
                                            src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group.png"
                                            srcSet="
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group.png 1x,
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group-2x.png 2x,
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group-3x.png 3x
                                            "
                                            alt="G3 Icons Group"
                                            sx={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    </Box>

                                    {/* Company Logos */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 3,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={keapWhite}
                                            alt="keap"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={teachableWhite}
                                            alt="teachable"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={foundrWhite}
                                            alt="foundr"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={clientPointWhite}
                                            alt="clientPoint"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                    </Box>
                                </>
                            ) : (
                                <Box sx={{ textAlign: 'left' }}
                                    margin="auto">

                                    <Box sx={{ textAlign: 'left' }}
                                        margin="auto">
                                        {/* Main heading */}
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '20px', sm: '24px', md: '28px' },
                                                fontWeight: 700,
                                                mb: '20px',
                                                textAlign: 'left'
                                            }}
                                        >
                                            Everything you need to host, automate, and grow,  all under one login.
                                        </Typography>
                                        {/* Features list */}
                                        <Box sx={{ mb: { xs: "16px", md: "20px" } }}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "12px", md: "16px" } }}>
                                                <Box sx={{ color: '#000000', fontSize: '20px', lineHeight: 1.2, mr: '12px', mt: '2px' }}>•</Box>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: { xs: '16px', xl: '18px' },
                                                        fontWeight: 600,
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    1 Master + 5 Pro + 20 Automated Accounts
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "12px", md: "16px" } }}>
                                                <Box sx={{ color: '#000000', fontSize: '20px', lineHeight: 1.2, mr: '12px', mt: '2px' }}>•</Box>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: { xs: '16px', xl: '18px' },
                                                        fontWeight: 600,
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    EasyCRM + EasyCast included
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "12px", md: "16px" } }}>
                                                <Box sx={{ color: '#000000', fontSize: '20px', lineHeight: 1.2, mr: '12px', mt: '2px' }}>•</Box>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: { xs: '16px', xl: '18px' },
                                                        fontWeight: 600,
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    AI Webinar Generator (Beta)
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Box sx={{ color: '#000000', fontSize: '20px', lineHeight: 1.2, mr: '12px', mt: '2px' }}>•</Box>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: { xs: '16px', xl: '18px' },
                                                        fontWeight: 600,
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    Priority onboarding & support
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Divider */}
                                    <Box
                                        sx={{
                                            width: '70%',
                                            height: '3px',
                                            background: 'linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.2) 20%, rgba(0, 0, 0, 0.2) 80%, transparent 100%)',
                                            opacity: 0.2,
                                            my: 5,
                                            mx: 'auto'
                                        }}
                                    />

                                    {/* G2 Badges Section */}
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            pb: 4,
                                            px: 2,
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#000000',
                                                fontSize: { xs: '18px', md: '18px', xl: '20px' },
                                                lineHeight: 1.4,
                                                mb: 3,
                                                textAlign: 'center',
                                                maxWidth: '500px',
                                                mx: 'auto'
                                            }}
                                        >
                                            Recognized by customers across the world as a leader in multiple categories on G2
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                flexWrap: { xs: 'wrap', md: 'nowrap' },
                                                gap: { xs: 2, md: 3 },
                                                maxWidth: '100%',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <img
                                                src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png"
                                                srcSet="
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png 1x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-2x.png 2x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-3x.png 3x
                                                "
                                                alt="G2 Badges - High Performer, Users Love Us, High Performer Asia Pacific, Leader Small Business, Momentum Leader"
                                                style={{
                                                    maxWidth: '500px',
                                                    height: 'auto',
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>

                        {/* Right side - Form Section */}
                        <Box
                            sx={{
                                width: { xs: "100%", md: "50%" },
                                bgcolor: "#ffffff",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            {value === 1 && !noTrial ? (
                                <>
                                    <Box sx={{ textAlign: "center", mb: 2 }}>
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize={{ xs: "min(calc(20px + 8 * (100vw - 400px) / (1920 - 400)), 28px)", lg: "28px" }}
                                            mb="8px"
                                            textAlign="center"
                                            lineHeight="1.2"
                                        >
                                            Complete your purchase
                                        </Typography>
                                        <Typography
                                            color="#71757D"
                                            fontSize={{ xs: "min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)", lg: "16px" }}
                                            fontWeight="600"
                                            textAlign="center"
                                        >
                                            Secure checkout. No hidden fees.
                                        </Typography>
                                    </Box>
                                </>
                            ) : (
                                noTrial ? <><Box sx={{ position: "relative", textAlign: 'center' }}>
                                    <Typography
                                        color="#333333"
                                        fontWeight="700"
                                        fontSize={{ xs: "24px", xl: "30px" }}
                                        lineHeight="normal"
                                        mb="22px"
                                        display="inline-block"
                                        textAlign="center"
                                        sx={{ position: "relative" }}
                                    >
                                        Start Now <br />
                                        Go Live in Minutes
                                    </Typography>
                                </Box> </> : <>
                                    <Box sx={{ position: "relative", textAlign: 'center' }}>
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize={{ xs: "24px", xl: "30px" }}
                                            lineHeight="normal"
                                            mb="8px"
                                            display="inline-block"
                                            textAlign="center"
                                            sx={{ position: "relative" }}
                                        >
                                            Create your account
                                        </Typography>
                                    </Box>
                                    <Box display="flex" gap="12px" mb="24px" flexWrap="wrap" justifyContent="center" alignItems="center">
                                        {!isTrial ? (
                                            <>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    Get full access
                                                </Typography>
                                                <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    Cancel anytime
                                                </Typography>
                                                <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    No hidden fees
                                                </Typography>
                                            </>
                                        ) : (
                                            <Typography
                                                color="#666666"
                                                fontSize="14px"
                                            >
                                                No hidden fees
                                            </Typography>
                                        )}
                                    </Box>
                                </>)}

                            <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                <Box sx={{ display: "flex", justifyContent: "center", height: "4px" }}>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                        <Tab {...a11yProps(0)} sx={{
                                            '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                                                color: '#178EFC !important',
                                            },
                                            '&.MuiTabs-indicator': {
                                                backgroundColor: '#178EFC !important',
                                            },
                                        }} />
                                        <Tab {...a11yProps(1)} disabled={value !== 1} />
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    {/* -----------commented below code as per the requirement---------- */}
                                    {/* <Box width="100%" textAlign="center" mb="24px">
                                        <Box display="flex" mb="14px" justifyContent="center" flexWrap="wrap" gap="12px">
                                            <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleGoogleSignIn}>
                                                <Box mr={{ xs: "8px" }} display="flex"><GoogleIcon /></Box>
                                                <Typography variant="body1" color="#0C141D">Google</Typography>
                                            </Box>
                                            <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleLinkedinSignIn}>
                                                <Box mr={{ xs: "8px" }} display="flex"><LinkedInsmallIcon /></Box>
                                                <Typography variant="body1" color="#0C141D">Linkedin</Typography>
                                            </Box> */}
                                    {/* <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }}>
                            <Box mr={{ xs: "8px" }}><MicrosoftIcon /></Box>
                            <Typography variant="body1" color="#0C141D">Microsoft</Typography>
                        </Box> */}
                                    {/* </Box>
                                        <Box borderBottom="1px solid #D9D9D9" height="1px" position="relative" width={{ xs: "100%", sm: "76%" }} margin="24px auto 27px" > <Typography variant="body2" color="#667085" bgcolor="#ffffff" position="absolute" left="50%" sx={{ transform: "translate(-50%, -50%)" }} p="0 6px" whiteSpace="nowrap">Or  continue with email</Typography></Box>
                                    </Box> */}
                                    {/* -----------commented below code as per the requirement---------- */}

                                    <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb={{ xs: "24px", sm: "48px" }}>
                                        <Grid size={{ xs: 12 }}>
                                            <TextField
                                                variant="outlined"
                                                label="Work email"
                                                name="email"
                                                placeholder="you@company.com"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                error={!!formErrors.email}
                                                helperText={formErrors.email}
                                                disabled={isAutoRegistering}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        {/* Commented out firstName field - will be generated from email
                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                variant="outlined"
                                                label="First name"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                error={!!formErrors.firstName}
                                                helperText={formErrors.firstName}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                        {/* Commented out lastName field - will be empty
                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                variant="outlined"
                                                label="Last name"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                error={!!formErrors.lastName}
                                                helperText={formErrors.lastName}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                        {/* Commented out phone field - not required
                                        <Grid size={{ xs: 12 }}>
                                            <MuiPhone
                                                value=""
                                                onChange={() => {}}
                                                onBlur={() => {}}
                                                error={false}
                                                helperText=""
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                        {/* Password field commented out - will auto-generate strong password */}
                                        {/* <Grid size={{ xs: 12 }}>
                                            <TextField
                                                variant="outlined"
                                                label="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                error={!!passwordError}
                                                disabled={isAutoRegistering}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                        background: '#ffffff',
                                                        paddingRight: '0'
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                slotProps={{
                                                    input: {
                                                        endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                            sx={{ borderRadius: "2px", "&:hover": { backgroundColor: "unset" } }}
                                                            onMouseDown={handleMouseDownPassword}
                                                            onMouseUp={handleMouseUpPassword}
                                                            disabled={isAutoRegistering}  >
                                                            {!showPassword ? <Box display="flex" gap="4px" alignItems="center" color="#000000"><VisibilityIcon fontSize='small' />
                                                                <Typography component="span" color="#000000" fontSize="14px">Show</Typography></Box>
                                                                : <Box display="flex" gap="4px" alignItems="center" color="#000000">
                                                                    <VisibilityOffIcon fontSize='small'></VisibilityOffIcon> <Typography component="span" fontSize="14px">hide</Typography></Box>
                                                            }
                                                        </IconButton>
                                                        </InputAdornment>
                                                    },
                                                }}
                                                fullWidth
                                            />
                                            <PasswordStrengthIndicator password={formData.password} />
                                        </Grid> */}
                                    </Grid>
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        disabled={isLoading || isAutoRegistering}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textTransform: "unset",
                                            width: "100%",
                                            height: "51px",
                                            gap: "8px",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            margin: "auto",
                                            bgcolor: "#0382F7 !important",
                                            "&:hover": { bgcolor: "#006dd1 !important" },
                                            "&.Mui-disabled": {
                                                bgcolor: "#178EFC !important",
                                                opacity: 0.7
                                            }
                                        }}
                                        onClick={handleNext}
                                    >
                                        {isLoading || isAutoRegistering ? (
                                            <CircularProgress size={24} sx={{ color: 'white' }} />
                                        ) : (
                                            'Continue to setup'
                                        )}
                                    </Button>
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            mt: 2,
                                            mb: 2
                                        }}
                                    >
                                        {/* {!noTrial && <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#374151',
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            100% Free Trial • Cancel Anytime • No Hidden Fees
                                        </Typography> } */}
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#374151',
                                                fontSize: '10px',
                                                fontWeight: 400,
                                                lineHeight: 1.5,
                                                mt: 2,
                                            }}
                                        >
                                            By starting your plan, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                        </Typography>
                                    </Box>


                                </CustomTabPanel>

                                <CustomTabPanel value={value} index={1}>
                                    {/* <Box display="flex" justifyContent="space-between" marginBottom="20px" borderBottom="1px dashed #A3A3A3" paddingBottom="8px">
                                        <Typography color="#2B2B30" fontSize="16px">
                                            {formatPlanName(cleanPlanId || '')}
                                        </Typography>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            {(appliedPromo || getPlanPrice().monthlyEquivalent) && (
                                                <Typography
                                                    color="#666666"
                                                    fontSize="16px"
                                                    sx={{ textDecoration: 'line-through' }}
                                                >
                                                    {appliedPromo ? getPlanPrice().original : getPlanPrice().monthlyEquivalent}
                                                </Typography>
                                            )}
                                            <Typography color={(appliedPromo || getPlanPrice().monthlyEquivalent) ? "#22B060" : "#2B2B30"} fontSize="16px">
                                                {getPlanPrice().discounted}
                                            </Typography>
                                        </Box>
                                    </Box> */}

                                    {/*=====================prview monthly / yearly code ===================== */}
                                    {/* plan boxes */}
                                    {/* <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, mt: { xs: 1, sm: 0 } }}> */}
                                    {/* Monthly Plan */}
                                    {/* <Box
                                            sx={{
                                                flex: 1,
                                                bgcolor: !isYearly ? "#f8fafc" : "#ffffff",
                                                border: "2px solid",
                                                borderColor: !isYearly ? "#8b5cf6" : "#e5e7eb",
                                                borderRadius: "12px",
                                                p: { xs: "8px", sm: "10px" },
                                                cursor: isAutoRegistering ? "not-allowed" : "pointer",
                                                transition: "all 0.2s ease",
                                                maxWidth: "170px",
                                                width: "100%",
                                                opacity: isAutoRegistering ? 0.6 : 1,
                                                "&:hover": {
                                                    borderColor: !isYearly ? "#7c3aed" : "#d1d5db",
                                                },
                                            }}
                                            onClick={() => !isAutoRegistering && handleBillingPeriodChange(false)}
                                        >

                                            <Typography
                                                sx={{
                                                    color: !isYearly ? "#1f2937" : "#6b7280",
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    textAlign: "center",
                                                    mb: 0.5,
                                                }}
                                            >
                                                {calculateDynamicPricing().monthlyPrice}/month
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    color: "#6b7280",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    textAlign: "center",
                                                }}
                                            >
                                                (Monthly billing)
                                            </Typography>
                                        </Box> */}

                                    {/* Yearly Plan */}
                                    {/* <Box
                                            sx={{
                                                flex: 1,
                                                bgcolor: isYearly ? "#f8fafc" : "#ffffff",
                                                border: "2px solid",
                                                borderColor: isYearly ? "#8b5cf6" : "#e5e7eb",
                                                borderRadius: "12px",
                                                p: { xs: "8px", sm: "10px" },
                                                pt: { xs: "12px", sm: "10px" }, // Add extra top padding on mobile to accommodate badge
                                                cursor: isAutoRegistering ? "not-allowed" : "pointer",
                                                transition: "all 0.2s ease",
                                                position: "relative",
                                                maxWidth: "170px",
                                                width: "100%",
                                                opacity: isAutoRegistering ? 0.6 : 1,
                                                "&:hover": {
                                                    borderColor: isYearly ? "#7c3aed" : "#d1d5db",
                                                },
                                            }}
                                            onClick={() => !isAutoRegistering && handleBillingPeriodChange(true)}
                                        >
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: { xs: -7, sm: -8 }, // Adjust top position for mobile
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    bgcolor: "#22C55D",
                                                    color: "#ffffff",
                                                    fontSize: { xs: "8px", sm: "9px" }, // Smaller font on mobile
                                                    fontWeight: 600,
                                                    px: { xs: 0.8, sm: 1 }, // Smaller padding on mobile
                                                    py: { xs: 0.2, sm: 0.25 }, // Smaller padding on mobile
                                                    borderRadius: "4px",
                                                    zIndex: 2, // Ensure it stays on top
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {isYearly ? `Saving ${calculateDynamicPricing().savings}` : `Save ${calculateDynamicPricing().savings}`}
                                            </Box>

                                            <Typography
                                                sx={{
                                                    color: isYearly ? "#1f2937" : "#6b7280",
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    textAlign: "center",
                                                    mb: 0.5,
                                                }}
                                            >
                                                {calculateDynamicPricing().yearlyPrice}/month
                                            </Typography>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                                <Typography
                                                    sx={{
                                                        color: "#6b7280",
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    (Yearly billing)
                                                </Typography>
                                            </Box>
                                        </Box> */}
                                    {/* </Box> */}
                                    {/*=====================prview monthly / yearly code ===================== */}


                                    <Box display="flex" justifyContent="space-between" marginBottom="20px" borderBottom="1px dashed #A3A3A33D" paddingBottom="8px">
                                        <Box>
                                            <Typography color="#2B2B30" fontSize="16px" fontWeight={700}>
                                                Agency bundle
                                            </Typography>
                                            {/* <Typography
                                                sx={{
                                                    color: '#6B7280',
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    fontWeight: 500,
                                                    mt: 0.5,
                                                }}
                                            >
                                                500 live and <br />3,000 automated attendees
                                            </Typography> */}
                                        </Box>
                                        <Box textAlign="right">
                                            <Box display="flex" alignItems="center" gap={1} justifyContent="flex-end">
                                                <Typography color="#22B060" fontSize="16px" fontWeight={700}>
                                                    $5500/year
                                                </Typography>
                                            </Box>
                                            <Typography color="#A3A3A3" fontSize="16px">
                                                Yearly billing
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {!isTrial ? (
                                        <>

                                            <Box width="100%" mb="8px">
                                                <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                    Card Details
                                                </Typography>
                                                <Box width="100%" sx={{
                                                    position: "relative",
                                                    "& .CbHosted": {
                                                        borderRadius: '3px',
                                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                                        padding: '14px 16px',
                                                        "&:hover, &--focus": {
                                                            borderColor: '#666666',
                                                        }
                                                    }
                                                }}>
                                                    <CardComponent
                                                        ref={cardRef}
                                                        currency="USD"
                                                        showTestCards={true}
                                                        styles={{
                                                            border: "1px solid #666666",
                                                            base: {
                                                                padding: "14px 16px",
                                                                border: "1px solid #666666",
                                                                fontSize: '16px',
                                                                fontFamily: 'Inter, sans-serif',
                                                                color: '#333333',
                                                                '::placeholder': {
                                                                    color: '#667085',
                                                                },
                                                            },
                                                            invalid: {
                                                                color: '#ff0000',
                                                            },
                                                        }}
                                                        onChange={(status: any) => {
                                                            console.log('Card status:', status);

                                                            if (status.error) {
                                                                setCardError(status.error.message);
                                                                setIsCardValid(false);
                                                            } else if (!status.complete) {
                                                                // Clear error but indicate card is not complete
                                                                setCardError(null);
                                                                setIsCardValid(false);
                                                            } else {
                                                                // Card is complete and valid
                                                                setCardError(null);
                                                                setIsCardValid(true);
                                                            }
                                                        }}
                                                        onReady={() => {
                                                            console.log('Card component ready');
                                                            setIsCardReady(true);
                                                            setIsCardValid(false); // Reset validity when component is ready
                                                        }}
                                                        onBlur={() => {
                                                            console.log('Card component blurred');
                                                        }}
                                                        onFocus={() => {
                                                            console.log('Card component focused');
                                                        }}
                                                    />
                                                </Box>
                                                {cardError && (
                                                    <Typography color="error" fontSize="12px" mt={1}>
                                                        {cardError}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Box display="flex" justifyContent="end" flexDirection="column">
                                                {!showPromoField ? (
                                                    <>
                                                        {appliedPromo ? (
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    padding: '4px 8px',
                                                                    backgroundColor: '#F0FFF4',
                                                                    borderRadius: '4px',
                                                                    width: 'fit-content',
                                                                    marginLeft: 'auto'
                                                                }}
                                                            >
                                                                <Typography color="#1D9652" fontSize="14px">
                                                                    {appliedPromo.code} applied
                                                                </Typography>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    viewBox="0 0 16 16"
                                                                    fill="none"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        setAppliedPromo(null);
                                                                        setPromoCode('');
                                                                    }}
                                                                >
                                                                    <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                                </svg>
                                                            </Box>
                                                        ) : (
                                                            null
                                                            // <Typography
                                                            //     color="#2B2B30"
                                                            //     fontSize="16px"
                                                            //     display="flex"
                                                            //     justifyContent="end"
                                                            //     mb="8px"
                                                            //     sx={{
                                                            //         cursor: 'pointer',
                                                            //         '&:hover': {
                                                            //             textDecoration: 'underline'
                                                            //         }
                                                            //     }}
                                                            //     onClick={() => setShowPromoField(true)}
                                                            // >
                                                            //     Have a promo code?
                                                            // </Typography>
                                                        )}
                                                    </>
                                                ) : (
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="Promo Code:"
                                                        value={promoCode}
                                                        onChange={(e) => {
                                                            setPromoCode(e.target.value);
                                                            setPromoError('');
                                                        }}
                                                        error={!!promoError}
                                                        helperText={promoError}
                                                        sx={{
                                                            width: "100%",
                                                            marginBottom: "25px",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#C7C7C7',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },
                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        sx={{
                                                                            ".MuiTypography-root": {
                                                                                color: "#333333",
                                                                                fontWeight: "500",
                                                                                fontSize: "16px",
                                                                            },
                                                                            paddingRight: "10px",
                                                                        }}
                                                                    >
                                                                        <Box display="flex" justifyContent="center" alignItems="center">
                                                                            <Box
                                                                                sx={{
                                                                                    background: theme.palette.primary.main,
                                                                                    borderRadius: '4px',
                                                                                    padding: '4px 10px',
                                                                                    marginRight: '4px',
                                                                                    minWidth: '57px',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: '500',
                                                                                    color: '#fff',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={validateCoupon}
                                                                            >
                                                                                Apply
                                                                            </Box>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="17"
                                                                                height="16"
                                                                                viewBox="0 0 17 16"
                                                                                fill="none"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setShowPromoField(false);
                                                                                    setPromoError('');
                                                                                }}
                                                                            >
                                                                                <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                            </svg>
                                                                        </Box>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    ) : null}
                                    <Box sx={{
                                        flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                            width: '100%',
                                        }
                                    }} display="flex" flexDirection="column" justifyContent="space-between">
                                        <Box>
                                            <Box mb="8px">
                                                <Typography color='#667085' fontSize='15px' marginBottom="8px">Your Custom URL</Typography>
                                                <TextField
                                                    variant="outlined"
                                                    placeholder="https://your-brand.easywebinar.live"
                                                    value={formData.subdomain || ''}
                                                    onChange={(e) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            subdomain: e.target.value.toLowerCase()
                                                        }));
                                                        // Clear error when user starts typing
                                                        setFormErrors(prev => ({
                                                            ...prev,
                                                            subdomain: ''
                                                        }));
                                                    }}
                                                    error={!!formErrors.subdomain}
                                                    helperText={formErrors.subdomain}
                                                    disabled={isAutoRegistering}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#C7C7C7',
                                                            background: '#ffffff',
                                                            paddingRight: '0'
                                                        },

                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },

                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '11px 14px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment
                                                                    position="end"
                                                                    sx={{
                                                                        ".MuiTypography-root": {
                                                                            color: "#333333",
                                                                            fontWeight: "500",
                                                                            fontSize: "16px",
                                                                        },

                                                                        paddingRight: "19px",
                                                                    }}
                                                                >
                                                                    .easywebinar.live
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Box>
                                            {domainSuggestions.length > 0 && (
                                                <Box mt={1} mb={2}>
                                                    <Typography color="primary" fontSize="12px" mb={1}>
                                                        Available alternatives:
                                                    </Typography>
                                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                                        {domainSuggestions.map((suggestion, index) => (
                                                            <Button
                                                                key={index}
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={() => {
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        subdomain: suggestion
                                                                    }));
                                                                    setFormErrors(prev => ({
                                                                        ...prev,
                                                                        subdomain: ''
                                                                    }));
                                                                    setDomainSuggestions([]);
                                                                }}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    borderColor: '#D0D5DD',
                                                                    color: '#344054',
                                                                    padding: '2px 8px',
                                                                    minHeight: '24px',
                                                                    fontSize: '12px',
                                                                    '&:hover': {
                                                                        borderColor: '#667085',
                                                                        backgroundColor: '#F9FAFB'
                                                                    }
                                                                }}
                                                            >
                                                                {suggestion}
                                                            </Button>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            )}
                                            {!planId && <Box borderRadius="8px" bgcolor="#EDF6FF" p="24px 12px" color="#5A5475" >
                                                <Typography variant="body2" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)">URL Guidelines:</Typography>
                                                <Box>
                                                    <Box component="ul" sx={{ "& li": { listStyle: "disc", fontSize: "min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" } }} pl="20px" mt="8px" lineHeight="1.5">
                                                        <Box component="li">
                                                            Use lowercase letters, numbers and hyphens only
                                                        </Box>
                                                        <Box component="li">
                                                            3-30 characters long
                                                        </Box>
                                                        <Box component="li">
                                                            No spaces or special characters
                                                        </Box>
                                                        <Box component="li">
                                                            Cannot start or end with a hyphen
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>}
                                            <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '42px' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleGetStarted}
                                                    className="x-large-btn"
                                                    disabled={isLoading || isAutoRegistering || (!isTrial && !isCardValid)}
                                                    disableElevation
                                                    fullWidth
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        px: "44px",
                                                        height: "47px!important",
                                                        fontSize: "18px",
                                                        bgcolor: "#0382F7 !important",
                                                        "&:hover": { bgcolor: "#006dd1 !important" },
                                                        "&.Mui-disabled": {
                                                            bgcolor: "#cccccc !important",
                                                            color: "#666666 !important"
                                                        }
                                                    }}
                                                >
                                                    {isLoading || isAutoRegistering ? (
                                                        <CircularProgress size={24} sx={{ color: 'white' }} />
                                                    ) : !isTrial && !isCardValid ? (
                                                        'Please complete card details'
                                                    ) : (
                                                        'Start your subscription'
                                                    )}
                                                </Button>
                                            </Box>
                                            
                                        </Box>
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                mt: 2,
                                                mb: 2
                                            }}
                                        >
                                            {/* {!noTrial && <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#374151',
                                                    fontSize: '14px',
                                                    fontWeight: 400,
                                                    lineHeight: 1.5,
                                                }}
                                            >
                                                100% Free Trial • Cancel Anytime • No Hidden Fees
                                            </Typography> } */}
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#374151',
                                                    fontSize: '10px',
                                                    fontWeight: 400,
                                                    lineHeight: 1.5,
                                                    mt: 2,
                                                }}
                                            >
                                                By starting your plan, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CustomTabPanel>
                            </Box>
                        </Box >
                    </Box >
                </Box >
            </Box>
            <AccountVerification
                onClose={handleVerificationDialogClose}
                open={verificationDialogOpen}
                onProceed={handleVerificationDialogProceed}
                phoneNumber=""
                email={formData.email}
                password={formData.password}
                companyId={verificationData.companyId}
                companyName={verificationData.companyName}
                infLeadSquaredId={verificationData.infLeadSquaredId}
            />
        </>
    )
}
export default WebinarconAgencyBundleSignup
